import { render, staticRenderFns } from "./DamageAssessorCaseOppositePersonForm.vue?vue&type=template&id=532a11d6&scoped=true"
import script from "./DamageAssessorCaseOppositePersonForm.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseOppositePersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a11d6",
  null
  
)

export default component.exports